import { Controller } from "@hotwired/stimulus"

// Hide the bubble through Intercom's setting, not CSS on its elements: that CSS also hid the
// messenger, so Request callback opened nothing on mobile.
const SMALL_SCREEN = "(max-width: 992px)"

export default class extends Controller {
  connect() {
    this.query = window.matchMedia(SMALL_SCREEN)
    this.toggle = () => this.#hideLauncher(this.query.matches)
    this.query.addEventListener("change", this.toggle)
    this.toggle()
  }

  disconnect() {
    this.query.removeEventListener("change", this.toggle)
    this.#hideLauncher(false)
  }

  #hideLauncher(hidden) {
    window.Intercom?.("update", { hide_default_launcher: hidden })
  }
}
